/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-header-row[_ngcontent-%COMP%], mat-row[_ngcontent-%COMP%]{min-height:28px}\n/*# sourceMappingURL=cultural-resources.component.css.map*/"];
export { styles as styles };
